import { useEffect, type RefObject } from "react";

export function useStickyHeaderHeight(headerRef: RefObject<HTMLElement | null>, cssVariableName: string) {
  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;
    const rootStyle = document.documentElement.style;
    const syncHeaderHeight = () => rootStyle.setProperty(cssVariableName, `${header.offsetHeight}px`);
    syncHeaderHeight();
    if (!("ResizeObserver" in window)) return () => rootStyle.removeProperty(cssVariableName);
    const headerObserver = new ResizeObserver(syncHeaderHeight);
    headerObserver.observe(header);
    return () => {
      headerObserver.disconnect();
      rootStyle.removeProperty(cssVariableName);
    };
  }, [headerRef, cssVariableName]);
}
